import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Outlet, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/lib/auth";
import { BrandProvider } from "@/lib/brand";
import NavBar from "@/components/NavBar";
import Footer from "@/components/Footer";
import DemoTour from "@/components/DemoTour";
import ProtectedRoute from "@/components/ProtectedRoute";

import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Dashboard from "@/pages/Dashboard";
import Assessment from "@/pages/Assessment";
import Results from "@/pages/Results";
import Report from "@/pages/Report";
import Admin from "@/pages/Admin";
import Sample from "@/pages/Sample";
import SampleReport from "@/pages/SampleReport";
import Join from "@/pages/Join";
import AssessRedirect from "@/pages/AssessRedirect";
import Pricing from "@/pages/Pricing";
import Sales from "@/pages/Sales";
import Terms from "@/pages/Terms";
import Privacy from "@/pages/Privacy";
import Refund from "@/pages/Refund";

// Onboarding v2 — Growth Campaign flow. Replaces the monolithic Register page
// with a 5-screen guided journey: Account → Practice → Welcome → Campaign → Live.
import Step1Account from "@/pages/onboarding/Step1Account";
import Step2Practice from "@/pages/onboarding/Step2Practice";
import Step3Welcome from "@/pages/onboarding/Step3Welcome";
import Step4Campaign from "@/pages/onboarding/Step4Campaign";
import Step5Live from "@/pages/onboarding/Step5Live";

function Layout() {
  return (
    <div className="min-h-screen flex flex-col">
      <NavBar />
      <main className="flex-1"><Outlet /></main>
      <Footer />
      <DemoTour />
    </div>
  );
}

export default function App() {
  return (
    <BrandProvider>
      <AuthProvider>
        <BrowserRouter>
          <Toaster theme="dark" position="bottom-right" richColors />
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Landing />} />
              <Route path="/login" element={<Login />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/register" element={<Step1Account />} />
              <Route path="/register-legacy" element={<Register />} />
              <Route path="/onboarding/practice" element={<ProtectedRoute role="consultant"><Step2Practice /></ProtectedRoute>} />
              <Route path="/onboarding/welcome" element={<ProtectedRoute role="consultant"><Step3Welcome /></ProtectedRoute>} />
              <Route path="/onboarding/first-campaign" element={<ProtectedRoute role="consultant"><Step4Campaign /></ProtectedRoute>} />
              <Route path="/onboarding/campaign-live/:campaignId" element={<ProtectedRoute role="consultant"><Step5Live /></ProtectedRoute>} />
              <Route path="/join/:token" element={<Join />} />
              <Route path="/sample" element={<Sample />} />
              <Route path="/sample-report" element={<SampleReport />} />
              <Route path="/pricing" element={<Pricing />} />
              <Route path="/sales" element={<Sales />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/refund-policy" element={<Refund />} />
              <Route path="/c" element={<Assessment />} />
              <Route path="/c/:slug" element={<Assessment />} />
              {/* Legacy paths — permanently redirect to /c/:slug */}
              <Route path="/assess" element={<Navigate to="/c" replace />} />
              <Route path="/assess/:slug" element={<AssessRedirect />} />
              <Route path="/results/:id" element={<Results />} />
              <Route path="/report/:id" element={<Report />} />
              <Route path="/dashboard" element={<ProtectedRoute role="consultant"><Dashboard /></ProtectedRoute>} />
              <Route path="/admin" element={<ProtectedRoute role="admin"><Admin /></ProtectedRoute>} />
            </Route>
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </BrandProvider>
  );
}
